import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { Pin2Icon } from '@gem/icons';
import { Badge } from '@gem/ui-kit';

import { Group } from 'STORE/Groups/Group';

import { GroupDescription } from '../../components/GroupDescription/GroupDescription';
import { GroupListItem } from '../../components/GroupListItem/GroupListItem';
import { JoinStreamingButton } from '../../components/JoinStreamingButton/JoinStreamingButton';
import { useChannelItemPresenter } from './ChannelItem.presenter';
import styles from './ChannelItem.styles.m.css';

interface IChannelItemProps {
  group: Group;
  isShowSpaceIcon: boolean;
}

export const ChannelItem: FC<IChannelItemProps> = observer(({ group, isShowSpaceIcon }) => {
  const presenter = useChannelItemPresenter(group);

  return (
    <GroupListItem
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      group={group}
      isShowSpaceIcon={isShowSpaceIcon}
      isIconsCentered={!!presenter.backgroundStream}
      description={<GroupDescription group={group} />}
      badges={
        <>
          {presenter.hasUnread && (
            <Badge
              quantity={presenter.numberOfUnread || null}
              isMuted={group.muted}
            />
          )}
          {presenter.hasPinedIcon && <Pin2Icon className={styles.pin} />}
          {!!presenter.backgroundStream && (
            <JoinStreamingButton
              isActive={presenter.hasActiveStream}
              onClick={presenter.onJoinToStream}
            />
          )}
        </>
      }
    />
  );
});
